import { HONEYBADGER_IGNORE_PATTERNS } from '@/constants/honeybadger';
import Honeybadger from '@honeybadger-io/js';

export default (context, inject) => {
  Honeybadger.configure({
    apiKey: context.$config.honeybadgerApiKey,
    environment: context.$config.environment,
    revision: context.$config.appRevision,
    breadcrumbsEnabled: process.env.NODE_ENV === 'production'
  });

  Honeybadger.beforeNotify(notice => !HONEYBADGER_IGNORE_PATTERNS.some(pattern => pattern.test(notice.stack)));

  inject('honeybadgerGeneric', Honeybadger);
  context.$honeybadgerGeneric = Honeybadger;
};
